export const repaymentSource = {
  CUSTOMER: "Customer",
  CREDIT_OFFICER: "CreditOfficer",
};
